import { render, staticRenderFns } from "./infoPageNotFound.vue?vue&type=template&id=567d840d&scoped=true"
import script from "./infoPageNotFound.vue?vue&type=script&lang=js"
export * from "./infoPageNotFound.vue?vue&type=script&lang=js"
import style0 from "./infoPageNotFound.vue?vue&type=style&index=0&id=567d840d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567d840d",
  null
  
)

export default component.exports